import axios from 'axios'
import { cookies, logoutCookies } from '@/utils/cookies'
import router from '../../../router/index'
import { Notification } from 'element-ui'

function isTokenInvalidError(error) {
  const { message } = error.response.data
  return message === 'jwt expired'
}

function responseSuccessHandler(response) {
  return response.data
}

function responseErrorHandler(error) {
  if (error.response && isTokenInvalidError(error) && cookies.get('user')) {
    Notification({
      title: `請重新登入`,
      message: `您的登入資訊已過期，請重新登入，以確保資料的正確性。`,
      type: 'warning',
      position: 'top-right',
      duration: 0,
    })
    API.defaults.headers.common['x-access-token'] = undefined
    logoutCookies()
    setTimeout(() => {
      router.replace({ name: 'Login' })
    }, 3 * 1000)
  } else if (error.response && error.response.status >= 500) {
    alert('伺服器發生錯誤，請聯絡管理人員')
  } else if (error.code === 'ECONNABORTED') {
    console.log('api 請求逾時')
  }
  return Promise.reject(error)
}

function getBaseUrl() {
  var baseUrl = ''
  if (location.href.includes('localhost')) {
    baseUrl = 'https://staging.ap.gladmobile.com/'
  } else if (location.href.includes('staging.backstage.gladmobile.com')) {
    baseUrl = 'https://staging.ap.gladmobile.com/'
  } else if (location.href.includes('daisuki.backstage.gladmobile.com')) {
    baseUrl = 'https://test-fleet.gladmobile.com/'
  } else if (location.href.includes('staging-2.backstage.gladmobile.com')) {
    baseUrl = 'https://staging2.ap.gladmobile.com/'
  } else if (location.href.includes('backstage.gladmobile.com')) {
    baseUrl = 'https://test-fleet.gladmobile.com/'
  } else {
    baseUrl = 'https://' + window.location.hostname + '/'
  }
  return baseUrl
}
function getAPIUrl() {
  return getBaseUrl() + 'enterprise/api/web/'
}

const API = axios.create({
  baseURL: getAPIUrl(),
  timeout: 1000 * 6,
})

API.defaults.headers.common['x-access-token'] = cookies.get('user')
API.interceptors.response.use(responseSuccessHandler, responseErrorHandler)

API.getBaseUrl = getBaseUrl()
API.getAPIUrl = getAPIUrl()
export default API



// WEBPACK FOOTER //
// ./src/assets/js/libs/EnterpriseAPI.js